import LubricantDisposal from "./LubricantDisposal";

export default LubricantDisposal;
